import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable } from '@angular/core';
import { AbstractTuiPortalService } from '@taiga-ui/cdk/abstract';

/**
 * @deprecated create your own portal (see {@link https://taiga-ui.dev/portals Portals})
 * TODO: replace with {@link TuiDropdownPortalService} in 3.0
 */
import * as ɵngcc0 from '@angular/core';
let TuiPortalService = class TuiPortalService extends AbstractTuiPortalService {
};
TuiPortalService.ɵfac = function TuiPortalService_Factory(t) { return ɵTuiPortalService_BaseFactory(t || TuiPortalService); };
TuiPortalService.ɵprov = ɵɵdefineInjectable({ factory: function TuiPortalService_Factory() { return new TuiPortalService(); }, token: TuiPortalService, providedIn: "root" });
const ɵTuiPortalService_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TuiPortalService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiPortalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiPortalService };

//# sourceMappingURL=taiga-ui-cdk-components-portal-host.js.map